import { useBackendApi } from './backendApi';
import { Address, ExternalLink, Name } from './Types';

export enum PhoneNumberType {
  MOBILE = 'mobile',
  HOME = 'home',
  WORK = 'work',
  OTHER = 'other',
}


export interface PhoneNumberDto {
  number: string;
  type: PhoneNumberType;
}

export interface SearchContactsRequest {
  name?: string;
  emails?: string[];
  phoneNumbers?: string[];
}

enum ContactSource {
  NEKST = 'nekst',
  FUB = 'fub'
}

export enum ContactMatch {
  NAME = 'name',
  PHONE_NUMBER = 'phoneNumber',
  EMAIL = 'email',
}

export interface ContactSearchResult {
  personId?: number,
  name: Name,
  primaryEmail?: string,
  alternateEmail?: string[],
  phoneNumbers?: PhoneNumberDto[],
  address?: Address,
  companyName?: string,
  externalLinks?: ExternalLink[],
  matches: ContactMatch[],
  source: ContactSource,
}

export const useContactsSearchService = () => {
  const backendApi = useBackendApi();


  const searchContacts = async (
    request: SearchContactsRequest,
    connectionProfilesIds: number[]
  ): Promise<ContactSearchResult[]> => {
    const queryParams = new URLSearchParams();

    if (request.name) {
      queryParams.append('name', request.name);
    }

    if (request.emails && request.emails.length > 0) {
      queryParams.append('emails', request.emails.join(','));
    }

    if (request.phoneNumbers && request.phoneNumbers.length > 0) {
      queryParams.append('phoneNumbers', request.phoneNumbers.join(','));
    }

    queryParams.append('connectionProfilesIds', connectionProfilesIds.join(','))

    const results = await backendApi.get(`/contacts/search?${queryParams.toString()}`);

    return results as ContactSearchResult[]
  };

  return {
    searchContacts,
  };
};
